import Typography from '@cobliteam/ui/components/Typography';

import { cn } from '@cobliteam/ui/utils';
import type React from 'react';

interface DataTableCellBaseWithContent {
  title?: never;
  titleAlt?: string;
  onClick?: () => void;
  subtitle?: never;
  disableTitle?: boolean;
  disableSubtitle?: boolean;
  content: string | React.ReactNode;
  align?: 'left' | 'center' | 'right';
  className?: string;
}

interface DataTableCellBaseWithTitle {
  title: string;
  titleAlt?: string;
  subtitle?: string;
  disableTitle?: boolean;
  disableSubtitle?: boolean;
  content?: never;
  onClick?: () => void;
  align?: 'left' | 'center' | 'right';
  className?: string;
}

export type DataTableProps = DataTableCellBaseWithContent | DataTableCellBaseWithTitle;

const DataTableCell = ({ title, titleAlt, onClick, subtitle, disableTitle, disableSubtitle, content, align = 'left', className }: DataTableProps) => {
  if (content && typeof content === 'object') return content;

  if (content && typeof content !== 'object')
    return (
      <Typography
        onClick={onClick}
        color='secondary'
        title={disableTitle ? undefined : titleAlt || title}
        className={cn(
          'line-clamp-1',
          onClick ? 'cursor-pointer text-primary-9 hover:underline' : 'cursor-default',
          align === 'right' && 'text-right',
          align === 'center' && 'text-center',
          className
        )}
      >
        {content}
      </Typography>
    );

  return (
    <div className={cn('flex flex-col gap-1', align === 'right' && 'text-right')}>
      <Typography
        title={disableTitle ? undefined : titleAlt || title}
        color='secondary'
        onClick={onClick}
        variant='description-title'
        className={cn('line-clamp-1', onClick ? 'cursor-pointer text-primary-9 hover:underline' : 'cursor-default', align === 'right' && 'text-right', className)}
      >
        {title}
      </Typography>

      {subtitle ? (
        <Typography color='secondary' title={disableSubtitle ? undefined : subtitle} variant='caption-default' className={cn('line-clamp-1', align === 'right' && 'text-right')}>
          {subtitle}
        </Typography>
      ) : null}
    </div>
  );
};

export default DataTableCell;
